import { useState } from 'react';
import { Botao } from '../componentes/ui';
import { AdicionarCliente } from './AdicionarCliente';
import { AdicionarPorSped } from './AdicionarPorSped';

/**
 * "+ Adicionar" de cliente: à mão (o CNPJ puxa a Receita) ou por arquivo SPED.
 *
 * Mora aqui porque são duas telas que oferecem a mesma entrada — a carteira de
 * clientes e a aba Clientes de Empresas. Copiar o menu seria deixar duas
 * versões dele para divergir.
 *
 * Só para cliente: fornecedor e assessor nascem de uma empresa que já existe,
 * com o papel ligado na configuração — criar um "fornecedor" do zero daria
 * duas portas para o mesmo cadastro.
 */
export function BotaoAdicionarCliente(): JSX.Element {
  const [menuAberto, setMenuAberto] = useState(false);
  const [adicionando, setAdicionando] = useState<'manual' | 'sped' | null>(null);

  return (
    <>
      <div className="relative">
        <Botao onClick={() => setMenuAberto((a) => !a)} aria-expanded={menuAberto}>
          + Adicionar
        </Botao>

        {menuAberto && (
          <div className="absolute right-0 top-12 z-20 w-64 overflow-hidden rounded-painel border border-borda bg-superficie-elevada shadow-cartao">
            <button
              type="button"
              onClick={() => {
                setMenuAberto(false);
                setAdicionando('manual');
              }}
              className="flex w-full flex-col items-start gap-0.5 px-4 py-3 text-left transition-colors hover:bg-superficie-base"
            >
              <span className="text-sm text-conteudo-primario">Adicionar manualmente</span>
              <span className="text-xs text-conteudo-sutil">O CNPJ puxa os dados da Receita</span>
            </button>
            <button
              type="button"
              onClick={() => {
                setMenuAberto(false);
                setAdicionando('sped');
              }}
              className="flex w-full flex-col items-start gap-0.5 border-t border-borda px-4 py-3 text-left transition-colors hover:bg-superficie-base"
            >
              <span className="text-sm text-conteudo-primario">Adicionar por arquivo</span>
              <span className="text-xs text-conteudo-sutil">SPED, já com o cálculo do mês</span>
            </button>
          </div>
        )}
      </div>

      <AdicionarCliente aberto={adicionando === 'manual'} aoFechar={() => setAdicionando(null)} />
      <AdicionarPorSped aberto={adicionando === 'sped'} aoFechar={() => setAdicionando(null)} />
    </>
  );
}
